<template>
  <div
    :class="[isSidebarOpen === 'active' ? 'w-[320px]' : 'w-[96px]']"
    class="sticky top-28 z-10 flex-shrink-0 transition-all duration-300 xxl:w-[96px] xl:hidden"
  >
    <div
      class="flex min-h-[668px] flex-col justify-between gap-6 rounded-xl p-6"
      :class="[
        mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100 shadow-primary',
      ]"
    >
      <div class="flex flex-col gap-6">
        <span
          @click="toggleSidebar"
          class="flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded border xxl:hidden"
          :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
        >
          <Menu :size="20" :stroke-width="1.75" />
        </span>
        <div class="flex flex-col gap-5">
          <template v-for="(tool, index) in tools" :key="index">
            <template v-if="tool.link">
              <div v-if="tool.show">
                <RouterLink
                  :to="{
                    name: tool.link,
                  }"
                  @click.prevent="reloadRoute(tool.link)"
                  class="flex items-center text-sm font-medium xxl:justify-center"
                  :class="[
                    currentRoute === tool.link ? 'font-semibold' : '',
                    isSidebarOpen === 'active'
                      ? 'justify-between'
                      : 'justify-center',
                  ]"
                >
                  <span class="flex items-center gap-2">
                    <Search
                      v-if="tool.icon === 'search'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Wrench
                      v-if="tool.icon === 'wrench'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <span
                      :class="[toolsMenusAnimation ? 'block' : 'hidden']"
                      class="mt-[2px] xxl:hidden"
                      >{{ tool.name }}</span
                    >
                  </span>
                </RouterLink>
              </div>
            </template>
            <template v-else>
              <div
                v-if="tool.show"
                class="relative rounded-lg leading-none xxl:p-0"
                :class="[
                  activeToolMenus === index && isSidebarOpen === 'active'
                    ? 'bg-primary-10 p-3'
                    : '',
                  mode === 'dark' ? 'xxl:bg-dark-sidebar' : 'xxl:bg-white-100',
                ]"
              >
                <div
                  @click.prevent="setActiveToolMenus(index)"
                  class="flex cursor-pointer items-center text-sm font-medium xxl:justify-center"
                  :class="[
                    activeToolMenus === index ? 'font-semibold' : '',
                    isSidebarOpen === 'active'
                      ? 'justify-between'
                      : 'justify-center',
                  ]"
                >
                  <span class="flex items-center gap-2">
                    <ShieldUser
                      v-if="tool.icon === 'admin'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Waypoints
                      v-if="tool.icon === 'waypoints'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Settings
                      v-if="tool.icon === 'contacts'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Laptop
                      v-if="tool.icon === 'technical'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Lightbulb
                      v-if="tool.icon === 'tips'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Hammer
                      v-if="tool.icon === 'ethics'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <Grip
                      v-if="tool.icon === 'other'"
                      :size="24"
                      :stroke-width="1.75"
                    />
                    <span
                      :class="[toolsMenusAnimation ? 'block' : 'hidden']"
                      class="mt-[2px] xxl:hidden"
                      >{{ tool.name }}</span
                    >
                  </span>
                  <ChevronDown
                    :size="20"
                    :stroke-width="2"
                    class="transform transition-transform duration-150 xxl:hidden"
                    :class="[
                      activeToolMenus === index ? 'rotate-180' : '',
                      toolsMenusAnimation ? 'block' : 'hidden',
                    ]"
                  />
                </div>
                <transition
                  enter-active-class="transition-all duration-200"
                  leave-active-class="transition-all duration-100"
                  enter-from-class="opacity-0 max-h-0"
                  leave-from-class="opacity-100 max-h-96"
                  enter-to-class="opacity-100 max-h-96"
                  leave-to-class="opacity-0 max-h-0"
                >
                  <div
                    v-if="activeToolMenus === index"
                    :class="getConditionalClasses"
                    class="xxl:absolute xxl:left-[80px] xxl:top-0 xxl:z-20 xxl:w-[300px] xxl:rounded-lg xxl:p-4"
                  >
                    <ul
                      class="flex flex-col gap-2 xxl:mt-0"
                      :class="[
                        activeToolMenus === index ? 'mt-3' : '',
                        isSidebarOpen === 'active' ? '' : '!mt-0',
                      ]"
                    >
                      <li
                        v-for="(sub, key) in tool.subs"
                        :key="key"
                        class="leading-none"
                      >
                        <RouterLink
                          v-if="sub?.params"
                          :to="{
                            name: sub.link,
                            params: { id: loggedInUser.contact.contact_id },
                          }"
                          class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                          :class="[
                            currentRoute === sub.link ? 'text-primary-100' : '',
                          ]"
                          >{{ sub.name }}</RouterLink
                        >
                        <RouterLink
                          v-else
                          :to="{
                            name: sub.link,
                          }"
                          @click.prevent="reloadRoute(sub.link)"
                          class="text-sm font-medium transition-colors duration-200 hover:text-primary-100"
                          :class="[
                            currentRoute === sub.link ? 'text-primary-100' : '',
                          ]"
                          >{{ sub.name }}</RouterLink
                        >
                      </li>
                    </ul>
                  </div>
                </transition>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div>
        <span
          @click.prevent="handleSingOut"
          class="flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded border"
          :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-10']"
        >
          <LogOut
            :size="20"
            :stroke-width="1.75"
            class="rotate-180 transform"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ChevronDown,
  Grip,
  Hammer,
  Laptop,
  Lightbulb,
  LogOut,
  Menu,
  Search,
  Settings,
  ShieldUser,
  Waypoints,
  Wrench,
} from "lucide-vue-next";
import tools from "@L/data/tools";
import { useUserStore } from "@S/user";
import { useAuth } from "@CO/useAuth";

export default {
  name: "Tools",
  components: {
    ChevronDown,
    Grip,
    Hammer,
    Laptop,
    Lightbulb,
    LogOut,
    Search,
    Settings,
    Menu,
    ShieldUser,
    Wrench,
    Waypoints,
  },
  props: {
    mode: String,
  },
  setup() {
    const userStore = useUserStore();
    const { signOut } = useAuth();
    return {
      userStore,
      signOut,
    };
  },
  data() {
    return {
      tools: [],
      activeToolMenus: null,
      isSidebarOpen: "active",
      currentRoute: null,
      toolsMenusAnimation: true,
    };
  },
  methods: {
    setActiveToolMenus(index) {
      this.activeToolMenus = this.activeToolMenus === index ? null : index;
    },
    toggleSidebar() {
      this.isSidebarOpen === "active"
        ? (this.isSidebarOpen = "inactive")
        : (this.isSidebarOpen = "active");
      this.activeToolMenus = null;
    },
    reloadRoute(link) {
      this.$router.replace({ path: "/" }).then(() => {
        this.$router.push({
          name: link,
        });
      });
    },
    handleSingOut() {
      this.signOut();
    },
  },
  mounted() {
    this.currentRoute = this.$route.name;
    if (this.isAdmin) {
      this.tools = tools;
    } else {
      const updatedTools = tools.map((tool) => {
        if (tool.name === "Admin") {
          return { ...tool, show: false };
        }
        return { ...tool };
      });
      this.tools = updatedTools;
    }
  },
  watch: {
    currentRoute() {
      this.setActiveToolMenus(
        this.tools.findIndex((tool) =>
          tool.subs.some((sub) => sub?.link === this.currentRoute),
        ),
      );
    },
    isSidebarOpen(newVal) {
      if (newVal === "active") {
        setTimeout(() => {
          this.toolsMenusAnimation = true;
        }, 300);
      } else {
        this.toolsMenusAnimation = false;
      }
    },
  },
  computed: {
    isAdmin() {
      return this.loggedInUser?.global_admin;
    },
    loggedInUser() {
      return this.userStore.user;
    },
    getConditionalClasses() {
      let classes = [];
      if (this.isSidebarOpen !== "active") {
        classes.push(
          "absolute top-0 left-[80px] rounded-lg p-4 w-[300px] z-20",
        );
        if (this.mode === "dark") {
          classes.push("bg-dark-sidebar border border-dark-border");
        } else {
          classes.push("bg-white-100 shadow-primary");
        }
      }
      if (this.mode === "dark") {
        classes.push("xxl:bg-dark-sidebar xxl:border xxl:border-dark-border");
      } else {
        classes.push("xxl:shadow-primary xxl:bg-white-100");
      }
      return classes.join(" ");
    },
  },
};
</script>
